<template>
      <div class="HeadPortrait">
   <img :src="this.$store.state.userPhoto" alt="">
      </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.HeadPortrait {
  img{
  width: 60px;
  height: 60px;
  background: rgba(146, 120, 255, 1);
  border-radius: 50%;
  }
}
</style>